exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".email[data-v-6d333d74]{position:relative;padding-top:30px;box-sizing:border-box}.email.mb[data-v-6d333d74]{padding-top:0}\n", ""]);

